import { render, staticRenderFns } from "./BoxCalculationQuery.vue?vue&type=template&id=39fed156&"
import script from "./BoxCalculationQuery.vue?vue&type=script&lang=js&"
export * from "./BoxCalculationQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports